import {Component, Input, OnInit, SimpleChanges} from '@angular/core';
import {
  Aangifte, AangifteBerekening,
  AangifteRapport, BokkzAlgDataService, Box1Berekening, IncomeTaxEntity, OpbouwInkomenBox1, OpbouwLijfrente,
  SpecificatieLijfrente
} from "@snelstart-ventures/fiscaal/domain-logic";
import {BokkzIbDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import {AbstractControl, FormBuilder, FormControl, FormGroup} from "@angular/forms";
import {BehaviorSubject, combineLatest} from "rxjs";
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-overzicht-lijfrente',
  templateUrl: './overzicht-lijfrente.component.html',
  styleUrls: ['./overzicht-lijfrente.component.scss'],
  imports: [
    SharedUiDetailsModule,
    SharedUiFormControlsModule,
    CommonModule
  ]
})
export class OverzichtLijfrenteComponent implements OnInit {

    aangifte = {} as Aangifte;
    public incomeTaxEntity = {} as IncomeTaxEntity;

    @Input() partner = new BehaviorSubject<boolean>(false);
    public partnerBoolean = false;

    @Input() aangifteRapport = {} as AangifteRapport;
    @Input() partnerRapport = {} as AangifteRapport;
    @Input() berekening = {} as AangifteBerekening;
    @Input() partnerBerekening = {} as AangifteBerekening;

    specLijfrenteFormGroup = this.fb.group<AangifteRapport>({});
    specLijfrente = {} as AangifteRapport;
    berekeningBox1FormGroup = this.fb.group<AangifteBerekening>({});
    berekeningBox1 = {} as AangifteBerekening;

    constructor(public dataService: BokkzIbDataService, public dataAlgService: BokkzAlgDataService, private fb: FormBuilder) {
        this.specLijfrenteFormGroup = this.fb.group<AangifteRapport>(({
            specificatieLijfrente: this.fb.group<SpecificatieLijfrente>(({
                opbouw: this.fb.group<OpbouwLijfrente>(({
                    aftrekbareLijfrentePremie: null as unknown as number,
                    jaarruimte: null as unknown as number,
                    reserveringsruimte: null as unknown as number,
                    premieGrondslag: null as unknown as number,
                    reserveringsruimteMinEen: null as unknown as number,
                    reserveringsruimteMinTwee: null as unknown as number,
                    reserveringsruimteMinDrie: null as unknown as number,
                    reserveringsruimteMinVier: null as unknown as number,
                    reserveringsruimteMinVijf: null as unknown as number,
                    reserveringsruimteMinZes: null as unknown as number,
                    reserveringsruimteMinZeven: null as unknown as number,
                    betaaldePremiesVoorLijfrente: null as unknown as number,
                    benutteJaarrruimte: null as unknown as number,
                    benutteReserveringsruimte: null as unknown as number,
                    benutteReserveringsruimteMinEen: null as unknown as number,
                    benutteReserveringsruimteMinTwee: null as unknown as number,
                    benutteReserveringsruimteMinDrie: null as unknown as number,
                    benutteReserveringsruimteMinVier: null as unknown as number,
                    benutteReserveringsruimteMinVijf: null as unknown as number,
                    benutteReserveringsruimteMinZes: null as unknown as number,
                    benutteReserveringsruimteMinZeven: null as unknown as number,
                    lijfrenteVoorKind: null as unknown as number,
                    premieAovVerzekering: null as unknown as number,
                    premieAnwVerzekering: null as unknown as number,
                    premieOmzettingForBijStaking: null as unknown as number,
                    premieAfstortingFor: null as unknown as number,
                    premieOmzettingStakingsWinstInLijfrente: null as unknown as number,
                } as OpbouwLijfrente))
            } as SpecificatieLijfrente))
        } as AangifteRapport))
        this.berekeningBox1FormGroup = this.fb.group<AangifteBerekening>(({
            box1: this.fb.group<Box1Berekening>(({
                opbouwInkomen: this.fb.group<OpbouwInkomenBox1>(({
                    uitgavenVoorInkomensvoorzieningen: null as unknown as number,
                } as OpbouwInkomenBox1)),
            } as Box1Berekening)),
        } as AangifteBerekening))
    }

    public ngOnInit(): void {
        combineLatest([this.dataService.incomeTaxEntity, this.partner]).subscribe(
            ([incomeTaxEntity, partner]) => {
                this.partnerBoolean = partner;
                this.specLijfrenteFormGroup.reset();
                this.berekeningBox1FormGroup.reset();
                if (incomeTaxEntity.aangifte) {
                    const aangifte = incomeTaxEntity.aangifte as Aangifte;
                    this.aangifte = aangifte;
                    this.updateForm()
                    this.disableFormGroup(this.specLijfrenteFormGroup);
                    this.disableFormGroup(this.berekeningBox1FormGroup);
                }
            }
        );
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['aangifteRapport'] || changes['partnerRapport'] || changes['berekening'] || changes['partnerBerekening']) {
            this.updateForm();
        }
    }


    private updateForm() {
        if (this.partnerBoolean) {
            this.specLijfrente=this.partnerRapport;
            this.specLijfrenteFormGroup.patchValue(this.partnerRapport);
            this.berekeningBox1FormGroup.patchValue(this.partnerBerekening)
        } else {
            this.specLijfrente=this.aangifteRapport;
            this.specLijfrenteFormGroup.patchValue(this.aangifteRapport);
            this.berekeningBox1FormGroup.patchValue(this.berekening)
        }
    }

    disableFormGroup(formGroup: FormGroup | AbstractControl): void {
        if (formGroup instanceof FormGroup) {
            Object.keys(formGroup.controls).forEach((key) => {
                const control = formGroup.get(key);
                if (control instanceof FormControl) {
                    control.disable();
                } else if (control instanceof FormGroup) {
                    this.disableFormGroup(control);
                }
            });
        }
    }

}

